import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import { KeyboardTimePicker } from "@material-ui/pickers";

function TimePickerField({ fieldName, helperText, ...rest }) {
    return (
        <Field type="date" name={fieldName}>
            {({ field, form: { values, setFieldValue, touched, errors } }) => (
                <KeyboardTimePicker
                    {...rest}
                    mask="__:__"
                    onChange={({_d}) => setFieldValue(field.name, _d)}
                    value={values[field.name]}
                    ampm={false}
                    helperText={touched[field.name] ? errors[field.name] : helperText}
                    error={Boolean(touched[field.name]) && Boolean(errors[field.name])}
                    margin="normal"
                />
            )}
        </Field>
    );
}

TimePickerField.propTypes = {
    fieldName: PropTypes.string.isRequired,
    helperText: PropTypes.string,
    fullWidth: PropTypes.bool,
    variant: PropTypes.string,
    inputVariant: PropTypes.string,
    size: PropTypes.string,
};

TimePickerField.defaultProps = {
    helperText: undefined,
    fullWidth: true,
    variant: "dialog",
    inputVariant: "outlined",
    size: "small",
};

export default TimePickerField;
